// Widget-Plugin: Online
vcDashboardRegistry.register("online", {
    noTitle: false,
    defaults: { w: 5, h: 2, resizable: true, copyable: true, showSettings: true, openSettingsOnCreate: true },
    settingsDefaults: { SignalIds: [] },
    get popupTitle() { return vcDashboardResources.get("signalSettings"); },
    render: function ($container, item) {
        $container.html("<div class='dashboard-online-wrapper'>" + item.title + "</div>");
    },
    buildParams: function (settings) {
        var signalId = (settings.SignalIds && settings.SignalIds.length > 0) ? settings.SignalIds[0] : -1;
        var signalParam = { 'series': [] };
        signalParam.series.push({ bsaid: [signalId], rule: '[bsaid=' + signalId + ']', ruleType: 1 });

        var param = {
            'loggerID': settings.LoggerId,
            'SignalId': signalId
        };

        return { Param: param, SignalParam: signalParam };
    },
    loadChart: function ($item, settings) {
        var signalId = (settings.SignalIds && settings.SignalIds.length > 0) ? settings.SignalIds[0] : -1;
        var obj = $item.find(".dashboard-online-wrapper");
        obj.empty();
        obj.height($item.find(".dashboard-item-content").height());
        obj.DashboardOnlineValue({ invokeType: "addVisualBase", parameter: { SignalId: signalId } });

    },
    onLoad: function ($item, settings) {
        this.loadChart($item, settings);
    },
    buildFields: function (currentSettings, $el) {
        var signalOptions = vcDashboardPopup.getSignalOptions($el);
        var fields = [];
        if (signalOptions.length) {
            fields.push({ key: "SignalIds", label: vcDashboardResources.get("signal"), type: "searchselect", options: signalOptions, arrayIndex: 0 });
        }
        return fields;
    },
    onSettingsSave: function ($el, newSettings) {
        this.loadChart($el, newSettings);
    },
    init: function ($item, settings) {
        vcDashboardPopup.initPlugin($item, this, settings);
    },
    resize: function ($item, settings) {
        this.loadChart($item, settings);
    }
});